/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, RouteComponentProps, useHistory } from 'react-router-dom';
// import Chart from 'react-google-charts';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

export function AdminDashboard(routeProps: RouteComponentProps) {
  // 도서 관련
  const [sampleBookCount, setSampleBookCount] = useState<number>(0);
  const [isMainBookCount, setIsMainBookCount] = useState<number>(0);
  const [isBestBookCount, setIsBestBookCount] = useState<number>(0);
  const [isNewBookCount, setIsNewBookCount] = useState<number>(0);
  const [isRecommendationBookCount, setIsRecommendationBookCount] = useState<number>(0);
  const [isDisplayBookCount, setIsDisplayBookCount] = useState<number>(0);
  const [isColorBookCount, setIsColorBookCount] = useState<number>(0);
  // 게시글 관련
  const [qnaBoardCount, setQnaBoardCount] = useState<number>(0); // 질의응답
  const [errataBoardCount, setErrataBoardCount] = useState<number>(0); // 정오표
  const [lectureBoardCount, setLectureBoardCount] = useState<number>(0); // 강의자료실
  const [libBoardCount, setLibBoardCount] = useState<number>(0); // 일반자료실
  const [noticeBoardCount, setNoticeBoardCount] = useState<number>(0); // 공지사항
  // 주문 관련
  const [paymentWait, setPaymentWait] = useState<number>(0); // 입금대기
  const [paymentConfirm, setPaymentConfirm] = useState<number>(0); // 입금확인중
  const [paymentComplete, setPaymentComplete] = useState<number>(0); // 입금완료
  const [chargeComplete, setChargeComplete] = useState<number>(0); // 결제완료
  const [shippingReady, setShippingReady] = useState<number>(0); // 출고준비
  const [shippingComplete, setShippingComplete] = useState<number>(0); // 출고완료
  const [refund, setRefund] = useState<number>(0); // 환불
  const [orderCancel, setOrderCancel] = useState<number>(0); // 주문취소
  const dispatch = useDispatch();
  const history = useHistory();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getStatistics();
  }, []);

  // DashBoard 조회 API 호출
  const getStatistics = async () => {
    await server
      .getDashBoardStatistics()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setPaymentWait(payload.order.paymentWait);
          setPaymentConfirm(payload.order.paymentConfirm);
          setPaymentComplete(payload.order.paymentComplete);
          setChargeComplete(payload.order.chargeComplete);
          setShippingReady(payload.order.shippingReady);
          setShippingComplete(payload.order.shippingComplete);
          setRefund(payload.order.refund);
          setOrderCancel(payload.order.orderCancel);
          setNoticeBoardCount(payload.board.notice);
          setErrataBoardCount(payload.board.errata);
          setLectureBoardCount(payload.board.lecture);
          setLibBoardCount(payload.board.lib);
          setSampleBookCount(payload.samplebook.samplebookCnt);
          setQnaBoardCount(payload.board.qna);
          setIsMainBookCount(payload.book.mainCnt);
          setIsBestBookCount(payload.book.bestCnt);
          setIsNewBookCount(payload.book.newCnt);
          setIsRecommendationBookCount(payload.book.recommCnt);
          setIsDisplayBookCount(payload.book.displayCnt);
          setIsColorBookCount(payload.book.colorCnt);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // AdminDashboard 리턴값
  return (
    <>
      <main className="dashboard wrapper">
        <section className="streaming">
          <ul>
            <li>
              입금대기
              <Link to="/admin/sale/order-list/입금대기">
                <span>{Number(paymentWait).toLocaleString()}</span>
              </Link>
            </li>
            <li>
              입금확인중
              <Link to="/admin/sale/order-list/입금확인중">
                <span>{Number(paymentConfirm).toLocaleString()}</span>
              </Link>
            </li>
            <li>
              입금완료
              <Link to="/admin/sale/order-list/입금완료">
                <span>{Number(paymentComplete).toLocaleString()}</span>
              </Link>
            </li>
            <li>
              결제완료
              <Link to="/admin/sale/order-list/결제완료">
                <span>{Number(chargeComplete).toLocaleString()}</span>
              </Link>
            </li>
            <li>
              출고준비
              <Link to="/admin/sale/order-list/출고준비">
                <span>{Number(shippingReady).toLocaleString()}</span>
              </Link>
            </li>
          </ul>
        </section>
        <section className="boards">
          <div>
            <h3>주문처리 현황</h3>
            <ul>
              <Link to="/admin/sale/order-list/입금대기">
                <li>
                  입금대기
                  <span>{Number(paymentWait).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/sale/order-list/입금확인중">
                <li>
                  입금확인중
                  <span>{Number(paymentConfirm).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/sale/order-list/입금완료">
                <li>
                  입금완료
                  <span>{Number(paymentComplete).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/sale/order-list/결제완료">
                <li>
                  결제완료
                  <span>{Number(chargeComplete).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/sale/order-list/출고준비">
                <li>
                  출고준비
                  <span>{Number(shippingReady).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/sale/order-list/출고완료">
                <li>
                  출고완료
                  <span>{Number(shippingComplete).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/sale/order-list/환불">
                <li>
                  환불
                  <span>{Number(refund).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/sale/order-list/주문취소">
                <li>
                  주문취소
                  <span>{Number(orderCancel).toLocaleString()}</span>
                </li>
              </Link>
            </ul>
          </div>
          <div>
            <h3>게시글 현황</h3>
            <ul>
              <Link to="/admin/board/notice">
                <li>
                  공지사항
                  <span>{Number(noticeBoardCount).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/board/errata">
                <li>
                  정오표
                  <span>{Number(errataBoardCount).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/board/lecture-lib">
                <li>
                  강의자료실
                  <span>{Number(lectureBoardCount).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/board/lib">
                <li>
                  일반자료실
                  <span>{Number(libBoardCount).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/board/sample-book">
                <li>
                  견본도서요청
                  <span>{Number(sampleBookCount).toLocaleString()}</span>
                </li>
              </Link>
              {/* 20240530 질의응답 미사용으로 숨기기 처리 */}
              {/* <Link to="/admin/board/qna">
                <li>
                  질의응답
                  <span>{Number(qnaBoardCount).toLocaleString()}</span>
                </li>
              </Link> */}
            </ul>
          </div>
          <div>
            <h3>도서 현황</h3>
            <ul>
              <Link to="/admin/book/list/isMain">
                <li>
                  메인도서
                  <span>{Number(isMainBookCount).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/book/list/isBest">
                <li>
                  BEST도서
                  <span>{Number(isBestBookCount).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/book/list/isNew">
                <li>
                  신간도서
                  <span>{Number(isNewBookCount).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/book/list/isRecommendation">
                <li>
                  추천도서
                  <span>{Number(isRecommendationBookCount).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/book/list/isDisplay">
                <li>
                  전시도서
                  <span>{Number(isDisplayBookCount).toLocaleString()}</span>
                </li>
              </Link>
              <Link to="/admin/book/list/isColor">
                <li>
                  컬러도서
                  <span>{Number(isColorBookCount).toLocaleString()}</span>
                </li>
              </Link>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}
